/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

const Button = ({ type, disabled = false, className, children, ...props }: any) => {
  return (
    <button
      type={type || 'button'}
      className={`block rounded-xl py-2 px-4 truncate ${className} ${
        disabled ? 'disabled:opacity-75' : ''
      }`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button
